import { defaultSchema } from "rehype-sanitize";

export const newsHtmlSanitizeSchema = {
  ...defaultSchema,
  tagNames: [
    ...new Set([
      ...(defaultSchema.tagNames || []),
      "u",
      "table",
      "thead",
      "tbody",
      "tr",
      "th",
      "td",
    ]),
  ],
};

export const NEWS_REACTION_PREVIEW_LIMIT = 5;
export const COMMENT_SECTION_PLACEHOLDER_MIN_HEIGHT = 280;
